__turbopack_context__.v({
  "root": "w17yJa_root",
  "specBlock": "w17yJa_specBlock",
});
